import React, { useEffect, useState, useRef } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "./../../../components/card/card.jsx";
import { asset, machineProfile } from "../../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../../contexts/AuthContext.jsx";
import { useDashboardContext } from "../../../contexts/NewDashboardContext.jsx";
import { useNavigate, useRoutes } from "react-router-dom";
import { generateLocationToArray, Loader } from "../../../utils/helper";
import DataTable from "react-data-table-component";
import { LocationFilter } from "../../../components/LocationFilter/index.jsx";
import { matar } from "../../../api/index.js";

function MachineList() {
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState({ company: true });
  const { config } = useAuth();
  const { machineTypes } = useDashboardContext();
  const [deleteRow, setDeleteRow] = useState(null);
  const [changeStatus, setChangeStatus] = useState(null);
  const { updateMachineProfile } = useAuth();
  const canUpdate = updateMachineProfile();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  async function getData() {
    try {
      setLoading(true);
      const res = await matar.getWorkOrder({ page });
      if (res.ok) {
        const body = await res.json();
        let data = body.data?.data?.results;
        const totalPage = body.data?.data?.totalPage;
        if (data) {
          setTotalPage(totalPage);
          setDatas(data);
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }
  useEffect(() => {
    getData();
  }, [page]);

  const columns = [
    {
      name: "Asset ID",
      selector: (row) => row["id"],
      minWidth: "150px",
      maxWidth: "180px",
    },
    {
      name: "Asset Group",
      selector: (row) => row["asset_group"],

      minWidth: "200px",
      maxWidth: "250px",
    },
    {
      name: "Location",
      selector: (row) => row["location"],
      minWidth: "150px",
      maxWidth: "180px",
    },
    {
      name: "ACS Category A",
      selector: (row) => row["category_a"],
      minWidth: "150px",
      maxWidth: "180px",
    },
    {
      name: "ACS Category B",
      selector: (row) => row["category_b"],
      minWidth: "150px",
      maxWidth: "180px",
    },
  ];
  const ExpandedComponent = ({ data }) => {
    return (
      <div style={{ padding: "10px" }}>
        <Card className="border-theme">
          <CardBody>
            <div className={"row"}>
              <div className="col-md-9">
                <div>
                  Asset ID : <b>{data["id"]}</b>
                </div>
                <div>
                  Serial Number : <b>{data["serial_number"]}</b>
                </div>
                <div>
                  Owning Department : <b>{data["owning_department"]}</b>
                </div>
                <div>
                  Work Order Closed Date : <b>{data["wo_closed_date"]}</b>
                </div>
                <button
                  style={{ marginRight: "10px" }}
                  onClick={() =>
                    navigate("/machine-asset/asset-detail/" + data["id"])
                  }
                  type="button"
                  className="btn btn-outline-theme"
                >
                  View Detail
                </button>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  };

  const handleChangeLocationFilter = (location_id) => {
    setQuery((prev) => ({
      ...prev,
      location_id: location_id ? location_id : "",
    }));
  };

  const handleChangeMachineType = (machine_type_id) => {
    setQuery((prev) => ({
      ...prev,
      machine_type_id: machine_type_id,
    }));
  };

  const onChangeStatus = (e) => {
    setChangeStatus((prev) => ({
      ...prev,
      machine_status: e.target.value,
    }));
  };

  const prosesChangeStatus = async () => {
    try {
      const response = await machineProfile.updateStatus(
        changeStatus.id,
        changeStatus.machine_status
      );
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("Machine Status has been changed");

          setChangeStatus(null);
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
    }
  };
  const handlePageChange = (page) => {
    setPage(page);
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Asset</a>
            </li>
            <li className="breadcrumb-item active">Asset List</li>
          </ul>

          <hr className="mb-4" />

          <div id="datatable" className="mb-5">
            {/*<div className="row mb-2 justify-content-sm-end">*/}
            {/*  <div className="col-sm-3 mb-2 mb-sm-0">*/}
            {/*    <LocationFilter onChange={handleChangeLocationFilter} />*/}
            {/*  </div>*/}
            {/*</div>*/}
            <div className="row">
              <div className="col-md-12">
                <Card>
                  <CardBody>
                    <Loader loading={loading}>
                      <DataTable
                        highlightOnHover
                        expandableRows
                        expandableRowsComponent={ExpandedComponent}
                        theme="dark"
                        columns={columns}
                        data={datas}
                        pagination
                        paginationServer
                        paginationTotalRows={totalPage * 10}
                        onChangePage={handlePageChange}
                      />
                    </Loader>
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MachineList;
